import modules_payment from './payment/index.js'
import modules_form from './form/index.js'
import modules_files from './files/index.js'
import _actions_submit from './_actions/submit.js'
import _actions_get from './_actions/get.js'
import _actions_create from './_actions/create.js'
import _actions_change from './_actions/change.js'
import _actions_add_payment from './_actions/add_payment.js'
import _getters_show_payment from './_getters/show_payment.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_data from './_mutations/data.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        data: _mutations_data,
        loading: _mutations_loading,
    },
    getters:{
        show_payment: _getters_show_payment,
    },
    actions:{
        add_payment: _actions_add_payment,
        change: _actions_change,
        create: _actions_create,
        get: _actions_get,
        submit: _actions_submit,
    },
    modules:{
        files: modules_files,
        form: modules_form,
        payment: modules_payment,
    },
}